export const categories = [
  'ATV-Quads',
  'Cabrio',
  'Electric',
  'Economy',
  'Jeep Wrangler',
  'Jeep-SUV-Family',
  'Mini Vans',
  'Motorbikes',
  'Special',
  'Standard'
];